export default "__VITE_ASSET__m7cIIEz8__"